import { X } from "lucide-react";

const FingerprintDetailsModal = ({
  selectedModeData,
  theme,
  isRTL,
  language,
  onClose,
}) => {
  if (!selectedModeData) {
    return null;
  }

  return (
    /* Modal with Controlled Size */
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.72)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        padding: "20px",
      }}
      onClick={onClose}
    >
      {/* Modal Container */}
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: theme === "dark" ? "#1e293b" : "#ffffff",
          display: "flex",
          flexDirection: "column",
          width: "min(760px, 100%)",
          maxWidth: "760px",
          maxHeight: "85vh",
          borderRadius: "24px",
          overflowY: "auto",
          direction: isRTL ? "rtl" : "ltr",
          textAlign: isRTL ? "right" : "left",
          boxShadow: "0 30px 80px rgba(0,0,0,0.28)",
          padding: "28px 32px",
        }}
      >
        {/* Close Button - Top Right/Left */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "24px",
            gap: "16px",
          }}
        >
          <h3
            style={{
              margin: 0,
              fontSize: "20px",
              fontWeight: 800,
              color: selectedModeData.color,
              flex: 1,
            }}
          >
            {selectedModeData.label}
          </h3>
          <button
            onClick={onClose}
            style={{
              background: theme === "dark" ? "rgba(148,163,184,0.2)" : "rgba(226,232,240,0.8)",
              border: "none",
              cursor: "pointer",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: theme === "dark" ? "#94a3b8" : "#64748b",
              borderRadius: "10px",
              transition: "all 0.2s ease",
              flexShrink: 0,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = selectedModeData.color;
              e.currentTarget.style.color = "#fff";
              e.currentTarget.style.transform = "scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = theme === "dark" ? "rgba(148,163,184,0.2)" : "rgba(226,232,240,0.8)";
              e.currentTarget.style.color = theme === "dark" ? "#94a3b8" : "#64748b";
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            flex: 1,
            overflowY: "auto",
            paddingRight: isRTL ? "0" : "8px",
            paddingLeft: isRTL ? "8px" : "0",
          }}
        >
          <p
            style={{
              margin: 0,
              fontSize: "14px",
              color: theme === "dark" ? "rgba(226,232,240,0.7)" : "#64748b",
              fontWeight: 500,
              lineHeight: "1.6",
            }}
          >
            {selectedModeData.desc}
          </p>

          {/* Details List */}
          <div>
            <h4
              style={{
                margin: "0 0 16px 0",
                fontSize: "14px",
                fontWeight: 700,
                color: selectedModeData.color,
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              {language === "ar" ? "🔍 كيفية العمل" : "🔍 How It Works"}
            </h4>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              {selectedModeData.details.map((detail, idx) => (
                <div
                  key={idx}
                  style={{
                    display: "flex",
                    gap: "12px",
                    padding: "14px",
                    borderRadius: "10px",
                    background: theme === "dark"
                      ? `${selectedModeData.color}10`
                      : `${selectedModeData.color}08`,
                    borderLeft: isRTL ? "none" : `3px solid ${selectedModeData.color}`,
                    borderRight: isRTL ? `3px solid ${selectedModeData.color}` : "none",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = theme === "dark"
                      ? `${selectedModeData.color}18`
                      : `${selectedModeData.color}12`;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = theme === "dark"
                      ? `${selectedModeData.color}10`
                      : `${selectedModeData.color}08`;
                  }}
                >
                  <div
                    style={{
                      fontSize: "12px",
                      lineHeight: "1.6",
                      color: theme === "dark" ? "#e2e8f0" : "#1e293b",
                      flex: 1,
                      fontWeight: 500,
                    }}
                  >
                    {detail}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Important Info Box */}
          <div
            // style={{
            //   background: `linear-gradient(135deg, ${selectedModeData.color}15, ${selectedModeData.color}08)`,
            //   border: `2px solid ${selectedModeData.color}30`,
            //   borderRadius: "12px",
            //   padding: "16px",
            // }}
          >
            {/* <h5
              style={{
                margin: "0 0 8px 0",
                fontSize: "12px",
                fontWeight: 700,
                color: selectedModeData.color,
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              💡 {language === "ar" ? "معلومة مهمة" : "Important Info"}
            </h5> */}
            {/* <p
              style={{
                margin: 0,
                fontSize: "12px",
                lineHeight: "1.5",
                color: theme === "dark" ? "rgba(226,232,240,0.85)" : "#475569",
              }}
            >
              {selectedModeData.id === "deviceName"
                ? (language === "ar"
                  ? "تأكد من أن أسماء الأجهزة تتطابق تماماً مع الإعدادات. النظام حساس لحالة الأحرف والمسافات."
                  : "Ensure device names match exactly with your settings. The system is case-sensitive and space-sensitive.")
                : (language === "ar"
                  ? "الوضع التسلسلي يعمل بشكل أفضل عندما يقوم الموظفون بالنقر على نفس الجهاز مرتين - مرة عند الدخول ومرة عند الخروج."
                  : "Sequential mode works best when employees tap the same device twice - once for check-in and once for check-out.")}
            </p> */}
          </div>
        </div>

        {/* Close Button */}
        {/* <button
          onClick={onClose}
          style={{
            marginTop: "auto",
            padding: "12px",
            borderRadius: "10px",
            border: "none",
            background: selectedModeData.gradient,
            color: "#fff",
            fontSize: "13px",
            fontWeight: 700,
            cursor: "pointer",
            transition: "all 0.2s ease",
            boxShadow: `0 8px 20px ${selectedModeData.color}30`,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = `0 12px 30px ${selectedModeData.color}40`;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = `0 8px 20px ${selectedModeData.color}30`;
          }}
        >
          {language === "ar" ? "✓ فهمت" : "✓ Got It"}
        </button> */}
      </div>
    </div>
  );
};

export default FingerprintDetailsModal;
